import { render } from "./InmateFormActions.vue?vue&type=template&id=a6b4c7ce&ts=true"
import script from "./InmateFormActions.vue?vue&type=script&lang=ts"
export * from "./InmateFormActions.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__